import { bootCheckoutReturn, isCheckoutReturnPath } from "./returnBoot";

/**
 * THE RETURN PAGE'S BOOT, AS A SIDE EFFECT (security code review R-2). main.tsx
 * imports this FIRST (as `virtual:lura-payments-boot`, aliased here only while
 * PAYMENTS_ENABLED is true), so the reference is scrubbed and the quiet claim
 * taken before ./router evaluates and React Router snapshots the location.
 */
if (typeof window !== "undefined" && isCheckoutReturnPath(window.location.pathname)) bootCheckoutReturn();
